import { render, staticRenderFns } from "./LessonSlide.vue?vue&type=template&id=65df48d8&scoped=true"
import script from "./LessonSlide.vue?vue&type=script&lang=js"
export * from "./LessonSlide.vue?vue&type=script&lang=js"
import style0 from "./LessonSlide.vue?vue&type=style&index=0&id=65df48d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65df48d8",
  null
  
)

export default component.exports